import { atom } from 'recoil';
import { sessionStorageEffect } from '@app/recoil';
import { InboxMessage } from '../types';

const messageIsReadUpdatesState = atom<InboxMessage['id'][]>({
  key: 'messageIsReadUpdates',
  default: [],
  effects: [sessionStorageEffect('message_is_read_updates')],
});

export default messageIsReadUpdatesState;
